import React from 'react';
import { AppBar, Box, Toolbar, IconButton, Typography } from '@mui/material';
import { ArrowBackIosNew as BackIcon } from '@mui/icons-material';
import { Logout as LogoutIcon } from '@mui/icons-material';
import AnnouncementContext from '../context/AnnouncementContext';
import AnnouncementContainer from '../containers/AnnouncementContainer';

export const VIEWS = {
  CATEGORY: 'category',
  QUESTION: 'question',
  ACCOUNT_DELETION: 'account_deletion',
  FORM: 'form',
} 

export default function Header ({
  title,
  view,
  backIcon = <BackIcon />,
  onBack,
  onSignOut,
}) {
  const { announcements } = React.useContext(AnnouncementContext);

  function onSignOutClick () {
    if (typeof onSignOut === 'function') {
      onBack();
      onSignOut();
    }
  }

  return (
    <Box sx={{ borderBottom: '1px solid #E1E1E1' }}>
      <AppBar position='static' elevation={0} color='white'>
        <Toolbar>
          <IconButton color='inherit' aria-label='back' sx={{ mr: 2, fontWeight: 600, visibility: onBack ? 'inherit' : 'hidden' }} onClick={onBack}>
            {backIcon}
          </IconButton>
          <Typography variant='h6' color='inherit' component='div' sx={{ fontWeight: 600, flex: 1, textAlign: 'center' }}>
            {title}
          </Typography>
          <IconButton color='inherit' aria-label='back' sx={{ ml: 2, fontWeight: 600, visibility: onSignOut ? 'inherit' : 'hidden' }} onClick={onSignOutClick}>
            <LogoutIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <AnnouncementContainer announcements={announcements} view={view} />
    </Box>
  );
}